var REACT_ELEMENT_TYPE;function _jsx(type, props, key, children) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var defaultProps = type && type.defaultProps,childrenLength = arguments.length - 3;if (props || 0 === childrenLength || (props = { children: void 0 }), 1 === childrenLength) props.children = children;else if (childrenLength > 1) {for (var childArray = new Array(childrenLength), i = 0; i < childrenLength; i++) childArray[i] = arguments[i + 3];props.children = childArray;}if (props && defaultProps) for (var propName in defaultProps) void 0 === props[propName] && (props[propName] = defaultProps[propName]);else props || (props = defaultProps || {});return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: void 0 === key ? null : "" + key, ref: null, props: props, _owner: null };}import React from 'react';














const Select = /*#__PURE__*/React.forwardRef(
  (
  {
    id,
    label,
    options,
    disabled,
    hideLabel,
    hasErrors,
    className,
    name = '',
    onChange = () => {},
    onBlur = () => {}
  },
  ref) =>
  {
    const fieldStyles = hasErrors ?
    'border-error-300 focus:border-error-500 focus:ring-error-500 border-2 text-red-900' :
    'border-gray-300 border text-gray-900';

    return /*#__PURE__*/(
      _jsx("div", { className: className }, void 0, /*#__PURE__*/
      _jsx("div", { className: "relative w-full" }, void 0, /*#__PURE__*/
      _jsx("label", { htmlFor: id, className: hideLabel ? 'sr-only' : '' }, void 0,
      label
      ), /*#__PURE__*/
      React.createElement("select", {
        className: `${fieldStyles} disabled:text-gray-500 rounded-lg bg-gray-50 block flex-1 w-full text-sm p-2.5`,
        id: id,
        disabled: disabled,
        ref: ref,
        name: name,
        onBlur: onBlur,
        onChange: onChange },

      options.map(({ key, value, selected }) => /*#__PURE__*/
      _jsx("option", { value: value, selected: selected }, key,
      value
      )
      )
      )
      )
      ));

  }
);

export { Select };